import React, { ChangeEvent } from 'react'
import styled from 'styled-components'
import { ReactComponent as CheckboxTick } from '../../images/checkboxTick.svg'

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray4};

  label {
    display: flex;
    align-items: center;
  }
  span {
    padding-left: 10px;
  }
`

//hide default checkbox
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div<{ isChecked: boolean }>`
  position: relative;
  display: inline-block;
  width: 10px;
  height: 10px;
  background: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.gray2 : 'transparent'};
  border-radius: 2px;
  transition: all 150ms;

  border: ${({ isChecked, theme }) =>
    !isChecked
      ? `1px solid ${theme.colors.gray4}`
      : '1px solid transparent'};

  svg {
    visibility: ${({ isChecked }) => (isChecked ? 'visible' : 'hidden')};
    position: absolute;
    top: 1px;
  }
`

type Props = {
  isChecked: boolean
  label: string

  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const Checkbox: React.FC<Props> = (props) => {
  const { isChecked, label, onChange } = props

  return (
    <CheckboxContainer>
      <label>
        <HiddenCheckbox
          name={label}
          checked={isChecked}
          onChange={onChange}
        />
        <StyledCheckbox isChecked={isChecked}>
          <CheckboxTick />
        </StyledCheckbox>
        <span>{label}</span>
      </label>
    </CheckboxContainer>
  )
}

export default Checkbox
